/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateFeatureRequest } from '../models/CreateFeatureRequest';
import type { Feature } from '../models/Feature';
import type { PagedFeatures } from '../models/PagedFeatures';
import type { UpdateFeatureRequest } from '../models/UpdateFeatureRequest';
import { request as __request } from '../core/request';

export class FeaturesService {

    /**
     * Search for features
     * @returns PagedFeatures Success
     * @throws ApiError
     */
    public static async getFeatures({
query,
page = '0',
pageSize = '30',
}: {
/** Search term **/
query?: string,
/** Page number **/
page?: string,
/** Page size **/
pageSize?: string,
}): Promise<PagedFeatures> {
        const result = await __request({
            method: 'GET',
            path: `/features/`,
            query: {
                'query': query,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Create (or restore) a new Feature
     * @returns Feature Success
     * @throws ApiError
     */
    public static async postFeatures({
requestBody,
}: {
requestBody: CreateFeatureRequest,
}): Promise<Feature> {
        const result = await __request({
            method: 'POST',
            path: `/features/`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Get existing Feature
     * @returns Feature Success
     * @throws ApiError
     */
    public static async getFeatureByToken({
token,
}: {
token: string,
}): Promise<Feature> {
        const result = await __request({
            method: 'GET',
            path: `/features/${token}`,
            errors: {
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Delete existing Feature
     * @returns void 
     * @throws ApiError
     */
    public static async deleteFeatureByToken({
token,
}: {
token: string,
}): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/features/${token}`,
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Update existing Feature
     * @returns Feature Success
     * @throws ApiError
     */
    public static async patchFeatureByToken({
token,
requestBody,
}: {
token: string,
requestBody: UpdateFeatureRequest,
}): Promise<Feature> {
        const result = await __request({
            method: 'PATCH',
            path: `/features/${token}`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

}